export let routes = []
export const setRoutes = newRoutes => routes = newRoutes



// WEBPACK FOOTER //
// ./app/utils/data/routes.js